import React from 'react';
import { Container, Title, Paper, Text } from '@mantine/core';

export const ChangePasswordPage: React.FC = () => {
  return (
    <Container size="xl">
      <Paper withBorder p="xl">
        <Title order={2} mb="md">Change Password</Title>
        <Text c="dimmed">Update your account password.</Text>
      </Paper>
    </Container>
  );
};